export default __webpack_public_path__ + "static/media/locked.9386aa66.svg";